// Comprehensive task templates for Chore Haven
export const taskTemplates = {
  // Daily Tasks
  daily: [
    {
      title: "Make Your Bed",
      description: "Straighten sheets, fluff pillows, and make it neat",
      category: "cleaning",
      points: 10,
      estimatedTime: 5,
      emoji: "🛏️"
    },
    {
      title: "Brush Your Teeth",
      description: "Morning and evening dental care routine",
      category: "other",
      points: 5,
      estimatedTime: 3,
      emoji: "🦷"
    },
    {
      title: "Feed Pet",
      description: "Give your pet food and fresh water",
      category: "pets",
      points: 10,
      estimatedTime: 5,
      emoji: "🐕"
    },
    {
      title: "Pack School Bag",
      description: "Organize books, homework, and supplies for school",
      category: "organization",
      points: 10,
      estimatedTime: 10,
      emoji: "🎒"
    },
    {
      title: "Tidy Room",
      description: "Put toys away, clothes in hamper, desk organized",
      category: "cleaning",
      points: 15,
      estimatedTime: 15,
      emoji: "🧸"
    },
    {
      title: "Set/Clear Table",
      description: "Help with mealtime setup and cleanup",
      category: "dishes",
      points: 10,
      estimatedTime: 8,
      emoji: "🍽️"
    }
  ],

  // Weekly Tasks
  weekly: [
    {
      title: "Vacuum Bedroom",
      description: "Vacuum carpet and under furniture in your room",
      category: "cleaning",
      points: 25,
      estimatedTime: 20,
      emoji: "🔌"
    },
    {
      title: "Take Out Trash",
      description: "Empty all trash cans and take bins to curb",
      category: "cleaning",
      points: 20,
      estimatedTime: 15,
      emoji: "🗑️"
    },
    {
      title: "Organize Backpack",
      description: "Clean out papers, organize supplies, check for lost items",
      category: "organization",
      points: 15,
      estimatedTime: 20,
      emoji: "🎒"
    },
    {
      title: "Water Plants",
      description: "Check and water all household plants",
      category: "outdoor",
      points: 15,
      estimatedTime: 10,
      emoji: "🪴"
    },
    {
      title: "Clean Bathroom Mirror",
      description: "Wipe down mirrors and faucets in bathroom",
      category: "cleaning",
      points: 15,
      estimatedTime: 10,
      emoji: "🪞"
    },
    {
      title: "Organize Toy Box",
      description: "Sort toys, donate broken ones, organize by type",
      category: "organization",
      points: 20,
      estimatedTime: 25,
      emoji: "🧸"
    }
  ],

  // Kitchen & Dishes
  kitchen: [
    {
      title: "Load Dishwasher",
      description: "Rinse dishes and load them properly in dishwasher",
      category: "dishes",
      points: 15,
      estimatedTime: 10,
      emoji: "🍽️"
    },
    {
      title: "Unload Dishwasher",
      description: "Put clean dishes away in proper places",
      category: "dishes",
      points: 15,
      estimatedTime: 10,
      emoji: "✨"
    },
    {
      title: "Wipe Down Counters",
      description: "Clean kitchen counters and stovetop",
      category: "cleaning",
      points: 10,
      estimatedTime: 8,
      emoji: "🧽"
    },
    {
      title: "Sweep Kitchen Floor",
      description: "Sweep up crumbs and debris from kitchen floor",
      category: "cleaning",
      points: 15,
      estimatedTime: 10,
      emoji: "🧹"
    },
    {
      title: "Pack Lunch",
      description: "Prepare and pack your school lunch",
      category: "cooking",
      points: 15,
      estimatedTime: 15,
      emoji: "🥪"
    },
    {
      title: "Help Prep Dinner",
      description: "Assist with washing vegetables or simple food prep",
      category: "cooking",
      points: 20,
      estimatedTime: 20,
      emoji: "👨‍🍳"
    }
  ],

  // Laundry & Clothing
  laundry: [
    {
      title: "Sort Laundry",
      description: "Separate lights, darks, and delicates",
      category: "laundry",
      points: 10,
      estimatedTime: 10,
      emoji: "👕"
    },
    {
      title: "Fold Clothes",
      description: "Fold your clean laundry neatly",
      category: "laundry",
      points: 20,
      estimatedTime: 20,
      emoji: "👔"
    },
    {
      title: "Put Clothes Away",
      description: "Put folded clothes in dresser and hang items",
      category: "laundry",
      points: 15,
      estimatedTime: 15,
      emoji: "👕"
    },
    {
      title: "Match Socks",
      description: "Find pairs and fold socks together",
      category: "laundry",
      points: 10,
      estimatedTime: 10,
      emoji: "🧦"
    },
    {
      title: "Hang Up Clothes",
      description: "Hang shirts, dresses, and jackets properly",
      category: "laundry",
      points: 10,
      estimatedTime: 8,
      emoji: "👗"
    }
  ],

  // Outdoor & Seasonal
  outdoor: [
    {
      title: "Rake Leaves",
      description: "Gather fallen leaves into piles or bags",
      category: "outdoor",
      points: 30,
      estimatedTime: 45,
      emoji: "🍂"
    },
    {
      title: "Shovel Snow",
      description: "Clear walkway and driveway of snow",
      category: "outdoor",
      points: 35,
      estimatedTime: 30,
      emoji: "❄️"
    },
    {
      title: "Water Garden",
      description: "Water outdoor plants and garden beds",
      category: "outdoor",
      points: 15,
      estimatedTime: 15,
      emoji: "🌻"
    },
    {
      title: "Collect Mail",
      description: "Get mail from mailbox and bring it inside",
      category: "other",
      points: 5,
      estimatedTime: 3,
      emoji: "📬"
    },
    {
      title: "Clean Up Yard",
      description: "Pick up toys, sticks, or debris from yard",
      category: "outdoor",
      points: 20,
      estimatedTime: 20,
      emoji: "🏡"
    },
    {
      title: "Wash Car",
      description: "Help wash the family car with soap and water",
      category: "outdoor",
      points: 30,
      estimatedTime: 45,
      emoji: "🚗"
    }
  ],

  // Pet Care
  pets: [
    {
      title: "Feed Cat/Dog",
      description: "Give pet their daily food and fresh water",
      category: "pets",
      points: 10,
      estimatedTime: 5,
      emoji: "🐕"
    },
    {
      title: "Walk the Dog",
      description: "Take dog for a walk around the neighborhood",
      category: "pets",
      points: 25,
      estimatedTime: 20,
      emoji: "🚶‍♂️"
    },
    {
      title: "Clean Litter Box",
      description: "Scoop and clean cat's litter box",
      category: "pets",
      points: 20,
      estimatedTime: 10,
      emoji: "🐱"
    },
    {
      title: "Brush Pet",
      description: "Groom pet by brushing their fur",
      category: "pets",
      points: 15,
      estimatedTime: 10,
      emoji: "🪮"
    },
    {
      title: "Clean Pet Toys",
      description: "Wash and organize pet's toys and accessories",
      category: "pets",
      points: 15,
      estimatedTime: 15,
      emoji: "🎾"
    },
    {
      title: "Fill Water Bowl",
      description: "Ensure pet has fresh, clean water available",
      category: "pets",
      points: 5,
      estimatedTime: 3,
      emoji: "💧"
    }
  ],

  // Organization & Tidying
  organization: [
    {
      title: "Organize Desk",
      description: "Clear desk surface, organize supplies in proper places",
      category: "organization",
      points: 15,
      estimatedTime: 15,
      emoji: "🗂️"
    },
    {
      title: "Sort Books",
      description: "Organize bookshelf by size, subject, or author",
      category: "organization",
      points: 20,
      estimatedTime: 25,
      emoji: "📚"
    },
    {
      title: "Clean Out Backpack",
      description: "Remove old papers, organize supplies, check for lost items",
      category: "organization",
      points: 15,
      estimatedTime: 15,
      emoji: "🎒"
    },
    {
      title: "Organize Closet",
      description: "Hang clothes properly, organize by type and season",
      category: "organization",
      points: 25,
      estimatedTime: 30,
      emoji: "👕"
    },
    {
      title: "Tidy Living Room",
      description: "Put items back where they belong, fluff cushions",
      category: "organization",
      points: 15,
      estimatedTime: 15,
      emoji: "🛋️"
    },
    {
      title: "Organize Art Supplies",
      description: "Sort crayons, markers, paper into proper containers",
      category: "organization",
      points: 15,
      estimatedTime: 20,
      emoji: "🎨"
    }
  ],

  // Educational & Homework
  homework: [
    {
      title: "Complete Math Homework",
      description: "Finish assigned math problems and check answers",
      category: "homework",
      points: 25,
      estimatedTime: 30,
      emoji: "🔢"
    },
    {
      title: "Reading Assignment",
      description: "Read assigned chapters or pages from textbook",
      category: "homework",
      points: 20,
      estimatedTime: 25,
      emoji: "📖"
    },
    {
      title: "Practice Spelling Words",
      description: "Write and practice weekly spelling vocabulary",
      category: "homework",
      points: 15,
      estimatedTime: 15,
      emoji: "✏️"
    },
    {
      title: "Science Project Work",
      description: "Work on ongoing science fair or class project",
      category: "homework",
      points: 30,
      estimatedTime: 45,
      emoji: "🔬"
    },
    {
      title: "Practice Instrument",
      description: "Practice piano, guitar, or other musical instrument",
      category: "other",
      points: 20,
      estimatedTime: 20,
      emoji: "🎹"
    },
    {
      title: "Study for Test",
      description: "Review notes and materials for upcoming exam",
      category: "homework",
      points: 25,
      estimatedTime: 30,
      emoji: "📝"
    }
  ],

  // Special Occasions & Seasonal
  seasonal: [
    {
      title: "Decorate for Holiday",
      description: "Help put up holiday decorations around the house",
      category: "other",
      points: 25,
      estimatedTime: 30,
      emoji: "🎄"
    },
    {
      title: "Wrap Presents",
      description: "Help wrap gifts for family birthdays or holidays",
      category: "other",
      points: 20,
      estimatedTime: 25,
      emoji: "🎁"
    },
    {
      title: "Bake Cookies",
      description: "Help bake and decorate cookies for special occasions",
      category: "cooking",
      points: 30,
      estimatedTime: 60,
      emoji: "🍪"
    },
    {
      title: "Plant Seeds",
      description: "Help plant flower or vegetable seeds in garden",
      category: "outdoor",
      points: 20,
      estimatedTime: 30,
      emoji: "🌱"
    },
    {
      title: "Prepare for Guests",
      description: "Help clean and prepare house for visiting family/friends",
      category: "cleaning",
      points: 25,
      estimatedTime: 30,
      emoji: "🏠"
    }
  ],

  // Technology & Learning
  technology: [
    {
      title: "Organize Digital Photos",
      description: "Help sort and organize family photos on computer",
      category: "technology",
      points: 20,
      estimatedTime: 25,
      emoji: "📸"
    },
    {
      title: "Learn New Skill Online",
      description: "Complete an educational video or online lesson",
      category: "technology",
      points: 25,
      estimatedTime: 30,
      emoji: "📱"
    },
    {
      title: "Help Grandparents with Tech",
      description: "Teach grandparents how to use phone, tablet, or computer",
      category: "technology",
      points: 30,
      estimatedTime: 20,
      emoji: "👴"
    }
  ]
}

// Quick task suggestions by age group
export const tasksByAge = {
  "3-5": [
    "Put toys in toy box",
    "Feed pet with help",
    "Make bed (pull covers up)",
    "Put dirty clothes in hamper",
    "Wipe up spills",
    "Match socks"
  ],
  "6-8": [
    "Set/clear table",
    "Load dishwasher",
    "Make simple snacks",
    "Vacuum small areas",
    "Dust furniture",
    "Sort recycling"
  ],
  "9-12": [
    "Take out trash",
    "Load/unload dishwasher",
    "Prepare simple meals",
    "Do laundry",
    "Clean bathroom",
    "Yard work"
  ],
  "13+": [
    "Deep clean rooms",
    "Grocery shopping",
    "Cook family meals",
    "Manage younger siblings",
    "Car maintenance",
    "Handle errands"
  ]
}

// Task difficulty levels
export const taskDifficulty = {
  beginner: {
    pointRange: [5, 15],
    timeRange: [5, 15],
    examples: ["Make bed", "Put toys away", "Feed pet"]
  },
  intermediate: {
    pointRange: [15, 25],
    timeRange: [15, 30],
    examples: ["Vacuum room", "Do dishes", "Fold laundry"]
  },
  advanced: {
    pointRange: [25, 40],
    timeRange: [30, 60],
    examples: ["Deep clean bathroom", "Organize closet", "Meal prep"]
  },
  expert: {
    pointRange: [40, 60],
    timeRange: [45, 90],
    examples: ["Wash car", "Organize garage", "Plan family activity"]
  }
}

// Helper function to get random tasks by category
export const getRandomTasks = (category, count = 5) => {
  const categoryTasks = taskTemplates[category] || []
  const shuffled = [...categoryTasks].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

// Helper function to get age-appropriate tasks
export const getAgeAppropriateTasks = (age) => {
  if (age <= 5) return getRandomTasks('daily', 3).concat(getRandomTasks('organization', 2))
  if (age <= 8) return getRandomTasks('daily', 2).concat(getRandomTasks('kitchen', 2), getRandomTasks('pets', 1))
  if (age <= 12) return getRandomTasks('weekly', 2).concat(getRandomTasks('laundry', 2), getRandomTasks('outdoor', 1))
  return getRandomTasks('seasonal', 1).concat(getRandomTasks('homework', 2), getRandomTasks('organization', 2))
}

// Helper function to get tasks by difficulty
export const getTasksByDifficulty = (difficulty) => {
  const allTasks = Object.values(taskTemplates).flat()
  const difficultyConfig = taskDifficulty[difficulty]
  
  if (!difficultyConfig) return []
  
  return allTasks.filter(task => {
    return task.points >= difficultyConfig.pointRange[0] && 
           task.points <= difficultyConfig.pointRange[1] &&
           task.estimatedTime >= difficultyConfig.timeRange[0] &&
           task.estimatedTime <= difficultyConfig.timeRange[1]
  })
}

export default taskTemplates